import FooterColumnStore from './FooterColumnStore';
import LocationStore from './LocationStore';
import { ExternalCallbackStore, TranslationsStore, EnvironmentStore, PropStateStore } from '../../common';
export class FooterRootStore {
    constructor(props) {
        Object.defineProperty(this, "externalCallbackStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "environmentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "propStateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translationsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "locationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "footerColumnStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.environmentStore = new EnvironmentStore(this, props);
        this.propStateStore = new PropStateStore(props);
        this.externalCallbackStore = new ExternalCallbackStore(props);
        this.locationStore = new LocationStore(this);
        this.translationsStore = new TranslationsStore(this, props.translations);
        this.footerColumnStore = new FooterColumnStore(this, props.columns);
    }
}
export default FooterRootStore;
//# sourceMappingURL=FooterRootStore.js.map